module.exports = __webpack_public_path__ + "img/9.87fd4254.png";